import _styled, { default as _styled2, default as _styled3, default as _styled4 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import { IconArrowForward, IconChevronRight } from '@noths/polaris-client-ribbons-design-system';
import * as styles from "./MegaNav.styles";
import { useTracking } from "../DepartmentsNav/hooks/useTracking/useTracking";
export var MegaNav = function MegaNav(_ref) {
  var departmentTitle = _ref.departmentTitle,
    departmentUrl = _ref.departmentUrl,
    level2Items = _ref.level2Items;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    openLevel2Index = _useState2[0],
    setOpenLevel2Index = _useState2[1];
  var tracking = useTracking();
  var handleLevel2Click = function handleLevel2Click(evt) {
    var _level2Items$openLeve;
    if (openLevel2Index === null) {
      return;
    }
    var isKeyboardClick = evt.detail === 0;
    if (isKeyboardClick && (_level2Items$openLeve = level2Items[openLevel2Index]) !== null && _level2Items$openLeve !== void 0 && _level2Items$openLeve.items.length) {
      var firstLevel3Item = document.querySelector("li[data-level=\"3\"] a:first-of-type");
      if (firstLevel3Item) {
        evt.preventDefault();
        firstLevel3Item.focus();
        return;
      }
    }
    tracking.onClickLink(evt, level2Items[openLevel2Index]);
  };
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: styles.container
  }, /*#__PURE__*/React.createElement(_StyledNav, {
    $_css2: styles.navContainer
  }, /*#__PURE__*/React.createElement(_StyledUl, {
    $_css3: styles.level2
  }, level2Items.map(function (level2Item, index) {
    var linkID = "level2-link-".concat(index);
    return /*#__PURE__*/React.createElement("li", {
      "aria-current": index === openLevel2Index,
      id: linkID,
      key: linkID,
      onMouseEnter: function onMouseEnter() {
        return setOpenLevel2Index(index);
      }
    }, level2Item.url ? /*#__PURE__*/React.createElement("a", {
      href: level2Item.url,
      onClick: handleLevel2Click,
      onFocus: function onFocus() {
        return setOpenLevel2Index(index);
      }
    }, level2Item.title, level2Item.items.length ? /*#__PURE__*/React.createElement(IconChevronRight, {
      height: 16,
      width: 16
    }) : null) : /*#__PURE__*/React.createElement("button", {
      onClick: handleLevel2Click,
      onFocus: function onFocus() {
        return setOpenLevel2Index(index);
      },
      type: "button"
    }, level2Item.title, level2Item.items.length ? /*#__PURE__*/React.createElement(IconChevronRight, {
      height: 16,
      width: 16
    }) : null));
  }), /*#__PURE__*/React.createElement("li", {
    onMouseEnter: function onMouseEnter() {
      return setOpenLevel2Index(null);
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: departmentUrl,
    onFocus: function onFocus() {
      return setOpenLevel2Index(null);
    }
  }, "See all ", departmentTitle, ' ', /*#__PURE__*/React.createElement(IconArrowForward, {
    color: "var(--brand-purple-base)",
    height: 16,
    width: 16
  })))), openLevel2Index !== null ? /*#__PURE__*/React.createElement(_StyledUl2, {
    "aria-labelledby": "level2-link-".concat(openLevel2Index),
    $_css4: styles.level3
  }, level2Items[openLevel2Index].items.map(function (level3Item, index) {
    return /*#__PURE__*/React.createElement("li", {
      "data-level": 3,
      key: index
    }, /*#__PURE__*/React.createElement("a", {
      href: level3Item.url,
      onClick: function onClick(evt) {
        return tracking.onClickLink(evt, level3Item);
      }
    }, level3Item.title));
  })) : null));
};
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledNav = _styled2("nav")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledUl = _styled3("ul")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledUl2 = /*#__PURE__*/_styled4("ul").withConfig({
  displayName: "MegaNav___StyledUl2",
  componentId: "sc-lmjzgx-0"
})(["", ""], function (p) {
  return p.$_css4;
});